module.exports = require('./helpers/bundle-url').getBundleURL('k3fDG') + "onboarding-step-3.2c445a77.png";